import React from 'react';
import set from 'lodash/set';
import { FORM_ERROR } from 'final-form';
import { Trans } from '@lingui/macro';

type Error = {
  name: string;
  details: Array<{
    code: string;
    fields: Array<string>;
    msg: string;
  }>;
};

type HttpErrorResponse = {
  response?: Error;
};

function formatBusinessRulesError(err: Error) {
  return err.details.reduce((acc, rule) => {
    let path = null;
    let error: any = null;

    switch (rule.code) {
      case 'PHONE_INVALID':
        path = 'policyholder.phone';
        error = <Trans id="error.invalidPhoneNumber" />;
        break;
      case 'ZIP_INVALID':
        path = 'policyholder.address.zip';
        error = <Trans id="error.invalidZip" />;
        break;
      case 'BILLING_ADDRESS_POSTCODE_INVALID':
        path = 'policyholder.billingAddress.zip';
        error = <Trans id="error.invalidZip" />;
        break;
      case 'MAXIMUM_AGE_ADULT':
        path = 'startDate';
        error = <Trans id="error.birthdateAdultAtStartdate" />;
        break;
      case 'MAXIMUM_AGE_CHILD':
        path = 'startDate';
        error = <Trans id="error.birthdateChildAtStartdate" />;
        break;
      case 'MAXIMUM_AGE_POLICYHOLDER':
        path = 'startDate';
        error = <Trans id="error.birthdateAtStartdate" />;
        break;
      case 'STARTDATE_TOO_FAR':
        path = 'startDate';
        error = <Trans id="error.startDateTooFar" />;
        break;
      case 'VAT_INVALID':
        path = 'policyholder.vatIn';
        error = <Trans id="error.invalidVat" />;
        break;
      default:
        path = FORM_ERROR;
        error = rule.msg;
        break;
    }

    if (error) {
      if (rule?.fields && Array.isArray(rule?.fields)) {
        rule.fields.forEach(field => {
          set(acc, field, error);
        });
      } else {
        set(acc, path, error);
      }
    }

    return acc;
  }, {});
}

export const errorHandler = (error: HttpErrorResponse) => {
  if (error?.response?.name === 'ValidationError') {
    return formatBusinessRulesError(error.response);
  }
  return undefined;
};

export const termsErrorHandler = (error: any) => {
  if (
    error?.response?.name === 'ValidationError' &&
    error?.response?.code === 'TOKEN-TERMS'
  ) {
    return {
      clientAgreement: <Trans id="error.tokenTermsExpired" />,
    };
  }
  throw error;
};
